import styled from 'styled-components';
// import MEDIA from 'helpers/mediaTemplates';

export const StyledTitle = styled.div`
  padding-bottom: 60px;
`;
